<template>
  <b-card header="Listado de proveedores">
    <b-row>
      <b-col cols="12">
        <div class="form-group form-inline pull-right">
          <input type="search" class="form-control" v-model="search" placeholder="Buscar"/> &nbsp;
          <button class="btn btn-primary" @click="addProvider()">Nuevo</button>
        </div>
        <table class="table table-bordered table-striped table-hover">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>RUC</th>
              <th>Propiedad</th>
              <th>Ratio de vueltas</th>
              <th>Pago inferior al ratio</th>
              <th>Pago superior o igual al ratio</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(provider, k) in paginated('filteredProviders')" :key=k>
              <td>{{provider.name}}</td>
              <td>{{provider.ruc ? provider.ruc : 'No indicado'}}</td>
              <td>{{provider.owner ? 'Propia' : 'Tercero'}}</td>
              <td>{{provider.ratio_limit}}</td>
              <td>{{provider.lower}}</td>
              <td>{{provider.higher}}</td>
              <td><a :href="'/fleet/providers/edit/'+provider.id"><span class="fa fa-edit fa-lg"></span></a> </td>
            </tr>
          </tbody>
        </table>
        <paginate name="filteredProviders" :list="filteredProviders" class="paginate-list" :per="10"></paginate>
        <paginate-links for="filteredProviders" :limit="5" :show-step-links="true" :step-links="{next: '>>',prev: '<<'}" :classes="{ 'ul': 'pagination', 'li': 'page-item', 'a': 'page-link',}"></paginate-links>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import api from '@/helpers/api'
export default {
  data(){
    return {
      providers: [],
      paginate: ['filteredProviders'],
      search: ''
    }
  },
  computed:{
    filteredProviders(){
      return this.providers.filter(p => {
        let condition = true
        if(this.search){
          condition = p.name.toLowerCase().includes(this.search.toLowerCase())
        }
        return condition
      })
    }
  },
  mounted(){
    api.get('/providers').then(response => {
      this.providers = response.providers
    })
  },
  methods: {
    addProvider(){
      this.$router.push('/fleet/providers/new')
    }
  }
}
</script>
